import CommandIdEnum from "../enums/CommandIdEnums";
import UserRightScopeEnum from "../enums/UserRightScopeEnum";
import UserRight from "../model/UserRight";

const hasRequiredRights = (userRight: UserRight, commandId: CommandIdEnum): boolean => {
    switch (commandId) {
        case CommandIdEnum.AddLengthDimension:
        case CommandIdEnum.AddTextAnnotation:
        case CommandIdEnum.AddChecklistItem:
        case CommandIdEnum.AddAreaAnnotation:
        case CommandIdEnum.AddRectangleAnnotation:
        case CommandIdEnum.AddCircleAnnotation:
            return userRight.create;
        case CommandIdEnum.RemoveFromDocument:
        case CommandIdEnum.DeleteSceneObject:
            return userRight.delete != UserRightScopeEnum.NoRights;
        case CommandIdEnum.EditProperties:
        case CommandIdEnum.MoveSceneObjects:
            return userRight.update != UserRightScopeEnum.NoRights;
        // Clone creates a new scene object and then positions it, so it needs both rights.
        case CommandIdEnum.CloneSceneObjects:
            return userRight.create && userRight.update != UserRightScopeEnum.NoRights;
        default:
            return false;
    }   
};

export default hasRequiredRights;
